import React from 'react'
import classNames from 'classnames'
import { useForm } from '@morningtrain/react-resources'

function QuantityEditor ({
  value,
  name,
  className,
  onChange,
  max = null,
  min = null
}) {
  const form = useForm()

  const _className = classNames(
    'quantity-input',
    'justify-center',
    className
  )

  const [internalValue, setInternalValue] = React.useState(value)

  React.useEffect(() => {
    if (value !== internalValue) {
      setInternalValue(value)
    }
  }, [value])

  React.useEffect(() => {
    if (typeof onChange === 'function') {
      onChange(internalValue)
    }
  }, [internalValue])

  const handleValueChange = (newValue, isIncrementer = false) => {
    if (newValue === null) {
      setInternalValue(null)
      return
    }

    newValue = parseInt(newValue)

    if (isNaN(newValue)) {
      newValue = 0
    }

    if (min !== null) {
      newValue = Math.max(min, newValue)
    }

    if (max !== null) {
      newValue = Math.min(max, newValue)
    }

    if (newValue !== internalValue) {
      form.setAsChanged()
      setInternalValue(newValue)
    }
  }

  return (
    <div className={_className}>
      <div className='quantity-input-border'>
        <div onClick={() => handleValueChange(internalValue - 1, true)} className='quantity-input__btn-wrap'>
          <button type='button'>-</button>
        </div>

        <div className='quantity-input__text'>
          <input
            name={name}
            value={internalValue !== null ? internalValue : ''}
            onChange={e => handleValueChange(e.target.value)}
          />
        </div>

        <div onClick={() => handleValueChange(internalValue + 1, true)} className='quantity-input__btn-wrap'>
          <button type='button'>+</button>
        </div>
      </div>
    </div>
  )
}

export default React.memo(QuantityEditor)
